import { useState } from 'react';
import {
  StyledLabelWrapper,
  StyledLabel,
  StyledTextareaWrapper,
  StyledTextarea,
} from './styles';

const OutlinedTextarea = ({
  error = false,
  className = '',
  label,
  value,
  placeholder = '',
  onChange,
  onFocus = null,
  onBlur = null,
  disabled = false,
  underline = false,
  id = '',
  rows = '3',
  resize = 'none',
}) => {
  const [focused, setFocused] = useState(false);

  const handleFocus = (e) => {
    setFocused(true);
    onFocus?.(e);
  };

  const handleBlur = (e) => {
    setFocused(false);
    onBlur?.(e);
  };

  const handleChange = (e) => {
    onChange(e.target.value);
  };

  return (
    <div className={className}>
      <StyledLabelWrapper htmlFor={id}>
        {label && <StyledLabel disabled={disabled}>{label}</StyledLabel>}
        <StyledTextareaWrapper
          focused={focused}
          error={error}
          underline={underline}
          disabled={disabled}
        >
          <StyledTextarea
            value={value}
            placeholder={placeholder}
            id={id}
            onChange={handleChange}
            onFocus={handleFocus}
            onBlur={handleBlur}
            disabled={disabled}
            rows={rows}
            resize={resize}
          />
        </StyledTextareaWrapper>
      </StyledLabelWrapper>
    </div>
  );
};

export default OutlinedTextarea;
